module.exports = __webpack_public_path__ + "img/error.282788bc.svg";